import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { addAlert, useMaterialUIController } from "context";
import { Group, GroupType } from "models/profile/Group";
import React from "react";
import { createGroupDO } from "utils/groupUtils";
import { EnumAutocomplete } from "components/alove/EnumAutocomplete";

const MDInput = require("components/MDInput").default;

export const AddGroupDialog = ({ onAdd }: { onAdd: () => void }) => {
  const [controller, dispatch] = useMaterialUIController();
  const [groupData, setGroupData] = React.useState({
    name: "",
    description: "",
    type: GroupType.Inclusive,
    statusId: 0 // active
  });

  const handleConfirm = async () => {
    try {
      const newGroup = Object.assign(new Group(), groupData);
      await createGroupDO(newGroup);
      addAlert(dispatch, "Group added successfully");
      // Reset form
      setGroupData({
        name: "",
        description: "",
        type: GroupType.Inclusive,
        statusId: 0
      });
      onAdd();
    } catch (error) {
      addAlert(dispatch, "Failed to add group", true);
    }
  };

  return (
    <AloveDialog
      dialogType={DialogType.AddGroup}
      dialogTitle="Add New Group"
      dialogBody="Enter the details for the new group"
      dialogConfirm="Add"
      valid={groupData.name.length > 0}
      handleConfirm={handleConfirm}
      width="500px"
    >
      <MDInput
        label="Group Name"
        placeholder="Enter group name"
        required
        value={groupData.name}
        onChange={(e: any) => setGroupData({ ...groupData, name: e.target.value })}
      />
      <MDInput
        label="Description"
        placeholder="Enter group description"
        value={groupData.description}
        multiline
        rows={3}
        onChange={(e: any) => setGroupData({ ...groupData, description: e.target.value })}
      />
      <EnumAutocomplete
        enumName={GroupType}
        value={groupData.type}
        onChange={(value) => setGroupData({ ...groupData, type: value })}
      />
    </AloveDialog>
  );
}; 